import { render } from "./BadgeTemplateEditor.vue?vue&type=template&id=55e7438c&scoped=true"
import script from "./BadgeTemplateEditor.vue?vue&type=script&lang=js"
export * from "./BadgeTemplateEditor.vue?vue&type=script&lang=js"

import "./BadgeTemplateEditor.vue?vue&type=style&index=0&id=55e7438c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e7438c"]])

export default __exports__